import { render } from "./RegisterNewServicesDGII.vue?vue&type=template&id=5d743dba"
import script from "./RegisterNewServicesDGII.vue?vue&type=script&lang=js"
export * from "./RegisterNewServicesDGII.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__